import { render } from "./CsvImport.vue?vue&type=template&id=283e1aba&scoped=true"
import script from "./CsvImport.vue?vue&type=script&lang=js"
export * from "./CsvImport.vue?vue&type=script&lang=js"

import "./CsvImport.vue?vue&type=style&index=0&id=283e1aba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283e1aba"]])

export default __exports__